import { Component } from 'react';
import store from 'store2';
import config from '../../config';

export default class Logout extends Component {
  componentDidMount() {
    store.clearAll();
    window.location.href = [
      config.auth.domain,
      `/user/logout?post_logout_redirect_uri=`,
      config.auth.postLogoutRedirectUri,
    ].join('');
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/auth/Logout.js